// extracted by mini-css-extract-plugin
module.exports = {"safeAppsContainer":"styles_safeAppsContainer__S4V_z"};